import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@store/authStore'
import { ReactNode } from 'react'

interface ProtectedRouteProps {
  children: ReactNode
  requiredRoles?: string[]
}

export function ProtectedRoute({ children, requiredRoles }: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAuthStore()
  const location = useLocation()

  // Check if user is authenticated
  if (!isAuthenticated) {
    // Save the location they were trying to access
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Check role-based access
  if (requiredRoles && requiredRoles.length > 0) {
    // Debug logging
    console.log('[ProtectedRoute] Required roles:', requiredRoles)
    console.log('[ProtectedRoute] User roles:', user?.roles)
    console.log('[ProtectedRoute] User object:', user)

    const hasRequiredRole = requiredRoles.some(role => user?.roles?.includes(role))
    console.log('[ProtectedRoute] Has required role:', hasRequiredRole)

    if (!hasRequiredRole) {
      console.warn('[ProtectedRoute] Access denied - missing required role')
      return <Navigate to="/unauthorized" replace />
    }
  }

  return <>{children}</>
}
